import { createActions } from 'redux-actions';

import types from 'state/direct-order/quote/actionTypes';

const { directOrder } = createActions({
  [types.SET_QUOTE]: (quote) => ({ quote }),
  [types.CLEAN_QUOTE]: () => ({}),
  [types.SET_QUOTE_ERROR]: ({ errorType }) => ({ errorType }),
  [types.CLEAN_QUOTE_ERROR]: () => ({}),
});

export default directOrder;
